import { render, staticRenderFns } from "./AdminConfigIndex.vue?vue&type=template&id=d707b20a"
import script from "./AdminConfigIndex.vue?vue&type=script&lang=js"
export * from "./AdminConfigIndex.vue?vue&type=script&lang=js"
import style0 from "./AdminConfigIndex.vue?vue&type=style&index=0&id=d707b20a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports